// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Modal from "@sothebys/sterling/modal";

var _map = {"regular":"regular","large":"large","fullscreen":"fullscreen"};

function modalSizeToJs(param) {
  return param;
}

function modalSizeFromJs(param) {
  return _map[param];
}

var make = Modal.Modal;

var Modal$1 = {
  modalSizeToJs: modalSizeToJs,
  modalSizeFromJs: modalSizeFromJs,
  make: make
};

var make$1 = Modal.Modal.Footer;

var Footer = {
  make: make$1
};

var make$2 = Modal.Modal.Header;

var Header = {
  make: make$2
};

var make$3 = Modal.Modal.Content;

var Content = {
  make: make$3
};

export {
  Modal$1 as Modal,
  Footer ,
  Header ,
  Content ,
}
/* make Not a pure module */
